import {
  ArrowLeftStroke,
  FileMultipleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { AritoActionButton } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the title for the form dialog based on form mode and active tab
 */
export const getFormTitle = (formMode: FormMode, activeTab: string) => {
  if (formMode !== 'view') {
    return formMode === 'add' ? 'Mới' : 'Sửa';
  }

  switch (activeTab) {
    case 'info':
      return 'Bút toán hủy/đảo';
    case 'history':
      return 'Lịch sử';
    default:
      return 'Bút toán hủy/đảo';
  }
};

/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    handleClose: () => void;
  }
) => {
  const { onAdd, onEdit, onDelete, onCopy, handleClose } = handlers;

  if (formMode !== 'view') {
    return null;
  }

  switch (activeTab) {
    case 'info':
      return (
        <>
          <AritoActionButton title='Thêm' icon={PlusStroke} onClick={onAdd} />
          <AritoActionButton title='Sửa' icon={Pencil1Stroke} onClick={onEdit} />
          <AritoActionButton title='Xóa' icon={Trash3Stroke} onClick={onDelete} />
          <AritoActionButton title='Sao chép' icon={FileMultipleStroke} onClick={onCopy} />
          <AritoActionButton title='Đóng' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
    case 'history':
      return (
        <>
          <AritoActionButton
            title='Refresh'
            variant='secondary'
            icon={RefreshCircle1ClockwiseStroke}
            onClick={() => console.log('refresh')}
          />
          <AritoActionButton
            title='Cố định cột'
            variant='secondary'
            icon={SignPostLeftStroke}
            onClick={() => console.log('pin')}
          />
          <AritoActionButton title='Đóng' variant='secondary' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
    default:
      return (
        <>
          <AritoActionButton title='Lưu' icon={FloppyDisk1Stroke} type='submit' />
          <AritoActionButton title='Đóng' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
  }
};
